// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderBlockInfoLabel_root__cRlXZ","infoLabelCustomButton":"HeaderBlockInfoLabel_infoLabelCustomButton__NKew5"};